import Vue from 'vue'
import { AbilityBuilder, Ability } from '@casl/ability'

const abilityPlugin = {

  ability: null,

  defineAbilities(acessos) {
    const { can, cannot, rules } = new AbilityBuilder()

    if(acessos)
    {
      for(let currentAcesso of acessos)
      {
        let area = currentAcesso.nome
        for(let currentAcessoParent of currentAcesso.acessos)
        {
          if(currentAcessoParent.isAcesso)
          {
            can(currentAcessoParent.nome, area)
          }
        }

        if(currentAcesso.children)
        {
          for(let currentChildren of currentAcesso.children)
          {
            let childrenArea = currentChildren.nome
            for(let currentChildrenAcesso of currentChildren.acessos)
            {
              if(currentChildrenAcesso.isAcesso)
              {
                can(currentChildrenAcesso.nome, childrenArea)
              }
            }
          }
        }
      }
    }

    this.ability = new Ability(rules)
  },

  can(acesso, area) {
    if(!this.ability) return false

    return this.ability.can(acesso, area)
  }

}

Vue.prototype.$ability = abilityPlugin

export default abilityPlugin
